const translatePasswordDistro = {
  message: 'Mesej ...',
  sender: 'Dari',
  receiver: 'Nombor telefon bimbit.',
  passwordDistor: 'PEMBAHAGIAN KATA LALUAN',
};

export default translatePasswordDistro;
